import axios from "axios";
import {storageService} from "@/app/services/StorageService";
import {storageKeys} from "@/app/[locale]/config/config";

export const requestInstance = axios.create();

requestInstance.defaults.baseURL = `${process.env.NEXT_PUBLIC_API_URL}`
requestInstance.defaults.headers['Accept'] = "application/json";

requestInstance.interceptors.request.use(
    async (config) => {
        config.headers.Authorization = storageService.exists(storageKeys.USER) ?
            `Bearer ${storageService.get(storageKeys.USER)}`
            : 'undefined';
        return config;
    },
    (error) => {
        Promise.reject(error)
    }
)